import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { dateToIso8601 } from '@utils/timeUtils';

const useNow = () => {
  const intl = useIntl();
  return useMemo(() => new Date(dateToIso8601(new Date(), intl)), [intl]);
};

export default useNow;
